const columns: TableColumn[] = [
  {
    Header: `Title`,
    accessor: `title`,
    dbKey: `title`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Description`,
    accessor: `description`,
    dbKey: `description`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Type`,
    accessor: `type`,
    dbKey: `type`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Access`,
    accessor: `accessLevel`,
    dbKey: `accessLevel`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Status`,
    accessor: `status`,
    dbKey: `status`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Date Range`,
    accessor: `dateRange`,
    dbKey: `startDate`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Created`,
    accessor: `createdAt`,
    dbKey: `createdAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Actions`,
    accessor: `actions`,
    dbKey: `actions`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  }
];

export default columns;
